import ApiInstance from './instance'
import {
  URL_MAPPING,
  IComment,
  ICreateCommentDTO,
  IUpdateCommentDTO
} from '@zunta/configurations'

const { comments: commentsUrls } = URL_MAPPING

export default class CommentApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  getCommentsList (statementId: number | string): Promise<IComment[]> {
    return this.instance.doGet(`${commentsUrls.prefix}${commentsUrls.getCommentsList.path}/${statementId}`, {}, 'getStatementsCommentsList')
  }

  createComment (commentData: ICreateCommentDTO): Promise<IComment> {
    return this.instance.doPost(`${commentsUrls.prefix}${commentsUrls.addComment.path}`, commentData)
  }

  updateComment (commentId: number | string, data: IUpdateCommentDTO): Promise<'OK'> {
    return this.instance.doPut(`${commentsUrls.prefix}${commentsUrls.updateComment.path}/${commentId}`, data)
  }

  deleteComment (commentId: number): Promise<'OK'> {
    return this.instance.doDelete(`${commentsUrls.prefix}${commentsUrls.deleteComment.path}/${commentId}`)
  }

  getLetterCommentsList (letterId: string | number): Promise<IComment[]> {
    return this.instance.doGet(`${commentsUrls.prefix}/letterComments/${letterId}`)
  }
}
